import { defineMessages } from 'react-intl';

export default defineMessages({
  account: {
    id: 'sentinel.components.accountPanel.accountTitle',
    defaultMessage: 'Account',
  },
  enterAccount: {
    id: 'sentinel.components.accountPanel.enterAccount',
    defaultMessage: 'Enter Account Number',
  },
  editAccount: {
    id: 'sentinel.components.accountPanel.editAccount',
    defaultMessage: 'Edit',
  },
  instructionSource: {
    id: 'sentinel.components.accountPanel.instructionSource',
    defaultMessage: 'Instruction Source',
  },
  accountData: {
    id: 'sentinel.components.accountPanel.accountData',
    defaultMessage: 'Account',
  },
  active: {
    id: 'sentinel.components.accountPanel.active',
    defaultMessage: 'Active',
  },
  correspondent: {
    id: 'sentinel.components.accountPanel.correspondent',
    defaultMessage: 'Correspondent',
  },
  ibDeposits: {
    id: 'sentinel.components.accountPanel.ibDeposits',
    defaultMessage: 'IB Deposits',
  },
  openedDate: {
    id: 'sentinel.components.accountPanel.openedDate',
    defaultMessage: 'Opened Date',
  },
  beneficiaryName: {
    id: 'sentinel.components.accountPanel.beneficiaryName',
    defaultMessage: 'Beneficiary Name',
  },
  beneficiaryAddress: {
    id: 'sentinel.components.accountPanel.beneficiaryAddress',
    defaultMessage: 'Beneficiary Address',
  },
  comingSoon: {
    id: 'sentinel.components.accountPanel.comingSoon',
    defaultMessage: 'Coming Soon',
  },
  viewAccountActivity: {
    id: 'sentinel.components.accountPanel.viewAccountActivity',
    defaultMessage: 'View Account Activity',
  },
  restrictions: {
    id: 'sentinel.components.accountPanel.restriction',
    defaultMessage: 'Restrictions',
  },
  yes: {
    id: 'sentinel.components.accountPanel.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'sentinel.components.accountPanel.no',
    defaultMessage: 'No',
  },
});



// WEBPACK FOOTER //
// ./src/components/AccountPanel/messages.js